module.exports = __webpack_public_path__ + "media/lobby-music2.02628914.mp3";